import { z } from 'zod';

const TextValidateEnum = z.enum(['email', 'required', 'sometimes']);
const TextAreaValidateEnum = z.enum(['required', 'sometimes']);
const SelectValidateEnum = z.enum(['required', 'sometimes']);

const BaseFieldSchema = z.object({
  type: z.string(),
  display: z.string(),
  width: z.number(),
  handle: z.string(),
});

// Schema for type select
const SelectFieldSchema = BaseFieldSchema.extend({
  type: z.literal('select'),
  options: z.array(
    z.object({
      key: z.string(),
      value: z.string(),
    })
  ),
  validate: z.array(SelectValidateEnum),
});

export type CMSSelectField = z.infer<typeof SelectFieldSchema>;

// Schema for type text area
const TextAreaFieldSchema = BaseFieldSchema.extend({
  type: z.literal('textarea'),
  character_limit: z.number(),
  validate: z.array(TextAreaValidateEnum),
  placeholder: z.string(),
});

export type CMSInputTextAreaField = z.infer<typeof TextAreaFieldSchema>;

// Schema for type text
const TextFieldSchema = BaseFieldSchema.extend({
  type: z.literal('text'),
  validate: z.array(TextValidateEnum),
  placeholder: z.string(),
});

export type CMSInputTextField = z.infer<typeof TextFieldSchema>;

export const FieldSchema = z.discriminatedUnion('type', [
  SelectFieldSchema,
  TextAreaFieldSchema,
  TextFieldSchema,
]);

export const FieldArraySchema = z.array(FieldSchema);

export type FormField = z.infer<typeof FieldSchema>;

export const DynamicFieldSchema = z.record(z.string(), FieldSchema);

export const SubmitToSchema = z.object({
  default: z.string(), // This will be url
  display: z.string(),
});

export type SubmitTo = z.infer<typeof SubmitToSchema>;

const FormHTTPMethodSchema = z.enum(['POST', 'PUT', 'DELETE']);
export type FormHTTPMethodType = z.infer<typeof FormHTTPMethodSchema>;
export const SubmitMethodSchema = z.object({
  default: FormHTTPMethodSchema,
});

export type SubmitMethod = z.infer<typeof SubmitMethodSchema>;

export const AdditionalFieldSchema = z.object({
  default: z.string(), //NOTE: will be used for additional field that are not present in frontend  enquiringAbout: "exetelComplaints"
});

export type AdditionalField = z.infer<typeof AdditionalFieldSchema>;
export const FormConfigSchema = z.object({
  submit_to: SubmitToSchema,
  submit_method: SubmitMethodSchema,
  additional_field: AdditionalFieldSchema,
});

const FieldsSchema = z.intersection(DynamicFieldSchema, FormConfigSchema);

const CMSFormDataResponseSchema = z.object({
  fields: FieldsSchema,
});

export const CMSFormResponseSchema = z.object({
  data: CMSFormDataResponseSchema,
});

export type CMSFormResponse = z.infer<typeof CMSFormResponseSchema>;

export type CMSFormDataResponse = z.infer<typeof CMSFormDataResponseSchema>;
